var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:((_vm.className || '') + " c-list-projects")},_vm._l((_vm.projects),function(project,index){return _c('BoxeProject',{key:index,attrs:{"project":project}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }